"use strict";

const { mixin } = require("../../utils");
const SVGElementImpl = require("./SVGElement-impl").implementation;
const SVGTestsImpl = require("./SVGTests-impl").implementation;

class SVGGraphicsElementImpl extends SVGElementImpl {}

SVGGraphicsElementImpl.attributeRegistry = new Map([
  ...SVGElementImpl.attributeRegistry,
  ...SVGTestsImpl.attributeRegistry
]);

mixin(SVGGraphicsElementImpl.prototype, SVGTestsImpl.prototype);

exports.implementation = SVGGraphicsElementImpl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/nodes/SVGGraphicsElement-impl.js
// module id = UIPy
// module chunks = 0